import { render, staticRenderFns } from "./QuickLinksHold.vue?vue&type=template&id=4bde2970&"
import script from "./QuickLinksHold.vue?vue&type=script&lang=js&"
export * from "./QuickLinksHold.vue?vue&type=script&lang=js&"
import style0 from "./QuickLinksHold.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports